import { z } from "zod";

export const OnboardingAccountInfoItemSchema = z.object({
  Completed: z.boolean().optional(),
  EmployeesCompleted: z.boolean().optional(),
  GuideCompleted: z.boolean().optional(),
  InfoCompleted: z.boolean().optional(),
  BusinessUnitId: z.string().optional().optional(),
});

export type OnboardingAccountInfoItemType = z.infer<
  typeof OnboardingAccountInfoItemSchema
>;
